import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useGraphiQLActions } from "@graphiql/react";
import { collectionsStore } from "../store.js";
import { localStorageAdapter } from "../storage/local-storage.js";
import { SaveDialog } from "./save-dialog.js";
const CollectionsSessionActions = ({
  storage,
  readOnly = false,
  allowImportExport = true,
  allowReplace = true
}) => {
  useEffect(() => {
    void collectionsStore.getState().actions.init(storage ?? localStorageAdapter, {
      readOnly,
      allowImportExport,
      allowReplace
    });
  }, []);
  const { registerSaveHandler } = useGraphiQLActions();
  useEffect(() => {
    if (readOnly) {
      return;
    }
    return registerSaveHandler(
      (tab) => collectionsStore.getState().actions.requestSave(tab)
    );
  }, [readOnly, registerSaveHandler]);
  return /* @__PURE__ */ jsx(SaveDialog, {});
};
export {
  CollectionsSessionActions
};
//# sourceMappingURL=session-actions.js.map
